<template>
  <div class="forget">
    <transition name="fade">
      <pcode v-if="pcodeShow" @done="pcodeSelected"></pcode>
    </transition>
    <div class="container">
      <h2>重置密码</h2>
      <cus-input @pcodeClick="setPcode" type="number" :rules="rules" :pcode="pcode.value" class="input" v-model="phoneNum" placeholder="请输入手机号" @validatorHandler="validatorHandler(arguments,0)"></cus-input>
      <cus-input :rules="{required: true}" class="input" v-model="smsCode" placeholder="请输入验证码" @validatorHandler="validatorHandler(arguments,1)">
        <template v-slot:icon>
          <img class="icon" src="/images/account/account4.png" alt="">
        </template>
        <template v-slot:code>
          <div class="send-sms" @click="sendSms" :class="{disabled:sendSmsDisabled}">{{isCountDowning?`${countDown}S后重试`:'获取验证码'}}</div>
        </template>
      </cus-input>
      <cus-input class="input" :rules="{required: true}" :type="passwordShow?'text':'password'" v-model="password" placeholder="请输入新密码" @validatorHandler="validatorHandler(arguments,2)">
        <template v-slot:icon>
          <img class="icon" src="/images/account/account1.png" alt="">
        </template>
        <template v-slot:passwordShow>
          <img @click="passwordShow = !passwordShow" class="icon" :src="passwordShow?'/images/account/account3.png':'/images/account/account2.png'" alt="">
        </template>
      </cus-input>
      <cus-button @click="reset" class="primary" :disabled="buttonDisabled0||buttonDisabled1||buttonDisabled2">确认</cus-button>
    </div>
  </div>
</template>
<script>
import { Base64 } from "js-base64";
import Pcode from "@/components/account/pcode";
import { LocalStorageUtil } from "@/utils";
import dayjs from "dayjs";
import { mapGetters, mapMutations } from "vuex";
import cussInput from "@/components/common/input";
export default {
  components: { Pcode, cussInput },
  data() {
    return {
      phoneNum: "",
      smsCode: "",
      password: "",
      pcodeShow: false,
      pcode: {
        name: "中国",
        value: "86",
        countryCode: "CHN"
      },
      passwordShow: false,
      buttonDisabled0: true,
      buttonDisabled1: true,
      buttonDisabled2: true
    };
  },
  mounted() {
    this.$store.dispatch("smsCode/initTimer");
  },
  computed: {
    ...mapGetters({
      countDown: "smsCode/countDown",
      isCountDowning: "smsCode/isCountDowning"
    }),
    validatorDisabled() {
      //中国代码才有电话号码验证
      this.phoneNum = "";
      return this.pcode.value != 86;
    },
    rules() {
      let ob = {
        required: true
      };
      !this.validatorDisabled && Object.assign(ob, { type: "tel" });
      return ob;
    },
    sendSmsDisabled() {
      return this.buttonDisabled0 || this.isCountDowning;
    }
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoadingShow"
    }),
    passwordShowFunc() {
      this.passwordShow = !this.passwordShow;
      this.$refs.password.focus();
    },
    validatorHandler(arg, index) {
      this.$set(this, "buttonDisabled" + index, !arg[0]);
    },
    setPcode() {
      this.pcodeShow = true;
    },
    pcodeSelected(item) {
      this.pcode = item;
      this.pcodeShow = false;
    },
    sendSms() {
      if (!this.sendSmsDisabled) {
        this.$store.dispatch("smsCode/sendSms", {
          phoneNum: this.phoneNum,
          countryCode: this.pcode.countryCode,
          pcode: this.pcode.value,
          module: "login"
        });
      }
    },
    reset() {
      this.setLoading({ show: true });
      let passwd = Base64.encode("@GZzib!" + this.password);
      this.$api
        .account_v1_user_reset_passwd_post({
          data: { phoneNum: this.phoneNum, smsCode: this.smsCode, passwd }
        })
        .then(e => {
          this.setLoading({ show: false });
          if (e) {
            this.$router.push("login");
          }
        });
    }
  }
};
</script>
<style scoped>
.forget {
  width: 100vw;
  height: 100vh;
  position: relative;
}
.forget h2 {
  color: #4e9df6;
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 48px;
}
.forget .container {
  padding: 32px 30px;
  box-sizing: border-box;
  /* position: absolute; */
  width: 100vw;
  /* top: 50%;
  left: 50%;
  transform: translate(-50%,-50%) */
}
.forget .container .input {
  margin-bottom: 7px;
}
.container >>> .cube-validator-msg-def {
  color: #fe2c2a;
  font-size: 12px !important;
  padding-left: 17px;
  line-height: 17px;
  margin-top: 2px;
  display: block;
}
.send-sms {
  width: 94px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  color: #74b3fa;
  border: 1px solid rgba(116, 179, 250, 1);
  border-radius: 8px;
  font-size: 14px;
  margin-left: 8px;
}
.send-sms.disabled {
  color: #d0d0d0;
  border: 1px solid rgba(208, 208, 208, 1);
}
</style>
